export default __webpack_public_path__ + "static/media/20_TopLeftSquares_Flip.5893d77c.mp4";